<!--
 * @Author: yeyimei
 * @Date: 2022-09-22 17:09:10
 * @LastEditTime: 2024-03-25 15:14:42
 * @LastEditors: yeyimei
 * @Description: 
 * @FilePath: \cardlan-h5-qrcode\src\App.vue
-->
<template>
  <router-view v-slot="{ Component }">
    <keep-alive :include="cachedViews">
    <component :is="Component"></component>
    </keep-alive>
  </router-view>
  <!-- 电影模块底部栏 -->
  <movie-tab-bar v-if="isMovieTabBar"></movie-tab-bar>
  <!-- 商城模块底部栏 -->
  <mall-tab-bar v-if="isMallTabBar"></mall-tab-bar>
  <!-- 土特产模块底部栏 -->
  <local-tab-bar v-if="isLocalTabBar"></local-tab-bar>
</template>
<script>
import movieTabBar from "@/components/movieTabBar"
import mallTabBar from "@/components/mallTabBar"
import localTabBar from "@/components/localTabBar"
import { mapGetters } from "vuex"
const wx = require("weixin-js-sdk")
export default {
  components: {
    movieTabBar,
    mallTabBar,
    localTabBar,
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters(["cachedViews"]),
    isMovieTabBar() {
      return this.$route.meta.isMovieTabBar || false
    },
    isMallTabBar() {
      return this.$route.meta.isMallTabBar || false
    },
    isLocalTabBar() {
      return this.$route.meta.isLocalTabBar || false
    },
  },
  created() {
    //获取运行环境
    var ua = navigator.userAgent.toLowerCase()
    var isWeixin = ua.indexOf("micromessenger") != -1
    this.$store.commit("isWeixin", isWeixin)
    if (isWeixin) {
      var version = ""
      var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
      if (wechatInfo && wechatInfo.length > 1) {
        // 获取微信的版本号
        localStorage.setItem("wxVersion", wechatInfo[1])
      }
    }
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          //在小程序里
          // localStorage.setItem("environment", "weixin")
          this.$store.commit("environment", "weixin")
        } else {
          //在微信浏览器中
          // localStorage.setItem("environment", "wxBrowser")
          this.$store.commit("environment", "wxBrowser")
        }
      })
    } else {
      //不在微信中
      // localStorage.setItem("environment", "outBrowser")
      this.$store.commit("environment", "outBrowser")
    }
    window.addEventListener("beforeunload", () => {
      //当浏览器窗口关闭或者刷新时触发
      localStorage.setItem("environment", this.$store.state.environment)
    })
  },
}
</script>
<style>
/*每个页面公共css */
@import url("../main.css");
.header {
  width: 100%;
  height: 44px;
  background: #00a5ff;
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
  display: flex;
  justify-content: center;
  align-items: center;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  height: 100vh;
  /* height:100%; */
  padding: 0;
  margin: 0;
  background: #f5f5f5;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
